import {QuestionsItemInterface} from "@/models/Question";

export const ROLE: string[] = [
    'ADMIN', 'EDITOR', 'USER'
];

export const CATEGORY: string[] = [
    'NIÑOS', 'ADULTOS'
];

export const ACTIVITY: string[] =[

];

export const VOZ: string[] = [
    'TEXTO A VOZ', 'VOZ', 'VOZ A TEXTO'
];

export const questions: QuestionsItemInterface[] =[
    {key: 'VERDADERO_Y_FALSO', text: 'Verdadero y falso'},
    {key: 'OPCION_MULTIPLE', text: 'Opción multiple'},
    {key: 'RELLENAR_FRASE', text: 'Rellenar frase'},
    {key: 'BUSCAR_PAR', text: 'Busca los pares'},
    {key: 'QUE_HAY_ARCHIVO', text: 'Que hay en el archivo'},
    {key: 'TEXTO_VOZ', text: 'Texto y voz'},
    {key: 'PREVIEW', text: 'Archivo de preview'},
    {key: 'ARCHIVO_MULTI_RESPUESTA', text: 'Archivo con mulples respuesta'},
];